import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.scss']
})
export class AppLoaderComponent implements OnInit {

  titulo: string; 

  constructor(public dialogRef: MatDialogRef<AppLoaderComponent>) {}

  ngOnInit(): void {

  }

}
